/* =============================================================
   Facas D'Avila — PDP Custom JS
   ZONA 1: Sticky cart + espelha preço do Dawn + WhatsApp float
   ============================================================= */

(function () {
  'use strict';

  /* --------------------------------------------------------
     Sticky Cart — aparece quando o botão "Add" sai da tela
  -------------------------------------------------------- */
  function initStickyCart() {
    var stickyCart   = document.getElementById('davila-sticky-cart');
    var stickyPrice  = document.getElementById('davila-sticky-price');
    var buySection   = document.querySelector('.davila-buy-buttons');
    var waFloat      = document.querySelector('.davila-whatsapp-float');

    if (!stickyCart || !buySection) return;

    // Botão do sticky aperta o add-to-cart original
    var stickyBtn = stickyCart.querySelector('.davila-sticky-cart__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var addBtn = document.querySelector('.product-form__submit, [name="add"]');
        if (addBtn) addBtn.click();
      });
    }

    // IntersectionObserver: mostra sticky quando buy-buttons sai do viewport
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting;
          stickyCart.classList.toggle('is-visible', visible);
          if (waFloat) waFloat.classList.toggle('cart-active', visible);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -60px 0px' }
    );

    observer.observe(buySection);
  }

  /* --------------------------------------------------------
     Espelha o preço do Dawn no sticky cart
     Dawn atualiza #price-{id} via fetch; observamos o DOM
  -------------------------------------------------------- */
  function initPriceMirror() {
    var stickyPriceEl = document.getElementById('davila-sticky-price');
    if (!stickyPriceEl) return;

    // Localiza o elemento de preço do Dawn (id começa com "price-")
    var dawnPriceEl = document.querySelector('[id^="price-"]');
    if (!dawnPriceEl) return;

    var observer = new MutationObserver(function () {
      var priceEl = dawnPriceEl.querySelector('.price-item--regular, .price-item--sale');
      if (priceEl) {
        stickyPriceEl.textContent = priceEl.textContent.trim();
      }
    });

    observer.observe(dawnPriceEl, { childList: true, subtree: true });
  }

  /* --------------------------------------------------------
     Atualiza preço D'Avila quando variante muda
     Escuta o evento nativo do Shopify via pubsub ou
     o evento variant:change do product-info.js do Dawn
  -------------------------------------------------------- */
  function initVariantPriceUpdate() {
    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variant) return;
      var variant = e.detail.variant;

      // Atualiza preço principal visível
      var priceEl = document.querySelector('.davila-price-value');
      if (priceEl && variant.price) {
        priceEl.textContent = formatMoney(variant.price);
      }

      // Atualiza preço no sticky
      var stickyPriceEl = document.getElementById('davila-sticky-price');
      if (stickyPriceEl && variant.price) {
        stickyPriceEl.textContent = formatMoney(variant.price);
      }

      // Atualiza preço riscado
      var compareEl = document.querySelector('.davila-price-compare s');
      var compareRow = document.querySelector('.davila-price-compare');
      if (compareEl && compareRow) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareRow.style.display = '';
        } else {
          compareRow.style.display = 'none';
        }
      }
    });
  }

  /* --------------------------------------------------------
     Formata centavos para R$ X.XXX,XX
  -------------------------------------------------------- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    // Formato BR: 1.234,56
    return 'R$\u00a0' + value
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* --------------------------------------------------------
     Tooltip do banner ENTREGA FULL
  -------------------------------------------------------- */
  function initEntregaFullTooltip() {
    var btn     = document.querySelector('[data-davila-tooltip="entrega-full"]');
    var tooltip = document.getElementById('tooltip-entrega-full');
    if (!btn || !tooltip) return;

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var hidden = tooltip.hasAttribute('hidden');
      tooltip.toggleAttribute('hidden', !hidden);
    });

    // Fecha ao clicar fora
    document.addEventListener('click', function () {
      tooltip.setAttribute('hidden', '');
    });
  }

  /* --------------------------------------------------------
     Overlay "+X fotos" na 5a imagem (desktop) — abre lightbox
  -------------------------------------------------------- */
  function initGalleryMoreOverlay() {
    var list = document.querySelector('.davila-pdp .product__media-list');
    if (!list) return;
    var items = list.querySelectorAll('.product__media-item');
    var visibleLimit = 5;
    if (items.length <= visibleLimit) return;

    var extraCount = items.length - visibleLimit;
    var lastVisible = items[visibleLimit - 1];
    if (!lastVisible) return;
    if (lastVisible.querySelector('.davila-gallery__more-overlay')) return;

    var overlay = document.createElement('div');
    overlay.className = 'davila-gallery__more-overlay';
    overlay.innerHTML =
      '<span>' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>' +
          '<circle cx="8.5" cy="8.5" r="1.5"/>' +
          '<polyline points="21 15 16 10 5 21"/>' +
        '</svg>' +
        '+' + extraCount + ' foto' + (extraCount > 1 ? 's' : '') +
      '</span>';

    overlay.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var opener = lastVisible.querySelector('.product__modal-opener');
      if (opener) {
        opener.click();
      } else {
        var img = lastVisible.querySelector('img');
        if (img) img.click();
      }
    });

    lastVisible.appendChild(overlay);
  }

  /* --------------------------------------------------------
     Modal de imagens: carrossel horizontal com setas + contador
  -------------------------------------------------------- */
  function initModalCarousel() {
    var modal = document.querySelector('product-modal.product-media-modal');
    if (!modal) return;
    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;

    // Adiciona setas + contador se ainda não existirem
    function ensureControls() {
      if (modal.querySelector('.davila-modal-arrow')) return;

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'davila-modal-arrow davila-modal-arrow--prev';
      prev.setAttribute('aria-label', 'Imagem anterior');
      prev.innerHTML =
        '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="15 18 9 12 15 6"/></svg>';

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'davila-modal-arrow davila-modal-arrow--next';
      next.setAttribute('aria-label', 'Próxima imagem');
      next.innerHTML =
        '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="9 18 15 12 9 6"/></svg>';

      var counter = document.createElement('div');
      counter.className = 'davila-modal-counter';

      modal.querySelector('.product-media-modal__dialog').appendChild(prev);
      modal.querySelector('.product-media-modal__dialog').appendChild(next);
      modal.querySelector('.product-media-modal__dialog').appendChild(counter);

      var scrollAmount = function () {
        return content.clientWidth || window.innerWidth;
      };

      prev.addEventListener('click', function (e) {
        e.preventDefault();
        content.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
      next.addEventListener('click', function (e) {
        e.preventDefault();
        content.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      // Dawn (global.js) fecha o modal em "pointerup" se target não estiver dentro de
      // deferred-media ou product-model. Interceptamos esse evento ANTES dele.
      // Clique direito/meio e clique na propria foto tambem nao fecham (abrir/salvar
      // imagem — 30/10); fecha pelo fundo escuro, X ou Esc.
      modal.addEventListener('pointerup', function (e) {
        if (e.button !== 0 || e.target.tagName === 'IMG' ||
            e.target.closest('.davila-modal-arrow, .davila-modal-counter')) {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }, true);

      var update = function () {
        var items = content.children;
        if (items.length === 0) return;
        var w = content.clientWidth || 1;
        var current = Math.round(content.scrollLeft / w) + 1;
        var total = items.length;
        counter.textContent = current + ' / ' + total;
        prev.hidden = content.scrollLeft <= 4;
        next.hidden = content.scrollLeft >= content.scrollWidth - w - 4;
      };
      content.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      // Teclado: ← →
      document.addEventListener('keydown', function (e) {
        if (!modal.classList.contains('media-modal--open') && !modal.hasAttribute('open')) {
          // Verificar via display (Dawn não usa classe, usa display:block)
          var style = window.getComputedStyle(modal);
          if (style.display === 'none') return;
        }
        if (e.key === 'ArrowLeft') prev.click();
        if (e.key === 'ArrowRight') next.click();
      });

      // Quando abre, scroll pra imagem clicada
      modal.addEventListener('toggle-modal', function () {
        setTimeout(update, 100);
      });

      setTimeout(update, 100);
    }

    // Quando o modal abre (via clique em qualquer .product__modal-opener)
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('.product__modal-opener, [data-modal]');
      if (!opener) return;
      // Aguarda o Dawn abrir o modal
      setTimeout(function () {
        ensureControls();
        // Scroll pro item clicado (se houver data-media-id)
        var mediaId = opener.getAttribute('data-media-id') ||
          (opener.closest('[data-media-id]') && opener.closest('[data-media-id]').dataset.mediaId);
        if (mediaId) {
          var target = content.querySelector('[data-media-id="' + mediaId + '"]');
          if (target) {
            content.scrollLeft = target.offsetLeft;
          }
        }
      }, 50);
    });

    // Ensure controls already if modal exists
    ensureControls();
  }

  /* --------------------------------------------------------
     Mobile PDP hero — move titulo/rating/badge PRA ANTES da galeria
     Somente em telas < 750px. Reversivel via 'restore' quando resize
     pra desktop. Nao duplica DOM (move os elementos originais).
  -------------------------------------------------------- */
  function initMobilePdpHero() {
    var zona = document.querySelector('.davila-zona1');
    if (!zona) return;
    var gallery = zona.querySelector('.davila-gallery');
    var info = zona.querySelector('.davila-info');
    if (!gallery || !info) return;

    var mq = window.matchMedia('(max-width: 749px)');
    var wrap = zona.querySelector('.davila-pdp-mobile-hero');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'davila-pdp-mobile-hero';
    }

    function apply() {
      if (mq.matches) {
        // Mobile: mover titulo -> attrs -> rating pra ANTES da gallery.
        // Materiais (sem label) logo abaixo do titulo, depois as estrelas.
        // Vendidas NAO vai pro hero — fica no .davila-info original,
        // aparecendo abaixo da foto (cor preta). Badge premio tambem nao
        // entra aqui (vive na gallery como overlay sobre a foto).
        var picks = [
          info.querySelector('.davila-product-title'),
          info.querySelector('.davila-product-attrs'),
          info.querySelector('.davila-rating'),
        ].filter(Boolean);
        if (!picks.length) return;
        picks.forEach(function (el) { wrap.appendChild(el); });
        if (wrap.parentNode !== zona || zona.firstChild !== wrap) {
          zona.insertBefore(wrap, gallery);
        }
      } else {
        // Desktop: devolver os elementos pra .davila-info (ordem original:
        // titulo, rating, attrs — sempre inseridos no topo).
        var kids = Array.prototype.slice.call(wrap.children);
        for (var i = kids.length - 1; i >= 0; i--) {
          info.insertBefore(kids[i], info.firstChild);
        }
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
      }
    }

    apply();
    // matchMedia change (viewport resize / rotacao)
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else mq.addListener(apply); // fallback Safari antigo
  }

  /* --------------------------------------------------------
     Aviso discreto na calculadora de frete (app MeuCorreios)
     O app cota a PDP somando o que JA esta no carrinho com o
     produto da pagina. Com outro item no carrinho, o Economico
     aparece "Gratis" e o cliente le como se fosse so' esta peca;
     no carrinho (sem ela) o frete aparece pago. Aqui so' explica
     o total considerado — nao muda calculo nenhum.
  -------------------------------------------------------- */
  function initAvisoFreteCarrinho() {
    var bloco = document.querySelector('[id^="correios-calc-"][id*="meucorreios"]');
    if (!bloco) return;
    var cfgs = window.CORREIOS_CALC_CONFIG || {};
    var cfg = cfgs[bloco.id.replace('correios-calc-', '')] || {};

    function brl(cents) {
      return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    function produtoAtual() {
      var form = document.querySelector('form[id^="product-form-"][id$="__main"]') ||
                 document.querySelector('form[action*="/cart/add"]');
      var inputId = form && form.querySelector('[name="id"]');
      var vid = parseInt((inputId && inputId.value) || cfg.variantId || '0', 10);
      var mapa = cfg.variantMap || {};
      var preco = (mapa[vid] && mapa[vid].priceCents) || cfg.productPriceCents || 0;
      var inputQtd = form && form.querySelector('[name="quantity"]');
      var qtd = Math.max(1, parseInt((inputQtd && inputQtd.value) || '1', 10) || 1);
      return { vid: vid, preco: preco, qtd: qtd };
    }

    function removerAviso() {
      var el = bloco.querySelector('[data-davila-aviso-frete]');
      if (el) el.remove();
    }

    function atualizar() {
      var resultados = bloco.querySelector('[data-results]');
      if (!resultados || resultados.style.display === 'none' || !resultados.textContent.trim()) {
        removerAviso();
        return;
      }
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var p = produtoAtual();
          var itens = (cart.items || []).filter(function (i) { return i.quantity > 0; });
          // Mesma regra do app: variante ja no carrinho nao entra de novo.
          var jaNoCarrinho = itens.some(function (i) { return i.variant_id === p.vid; });
          var outros = itens.filter(function (i) { return i.variant_id !== p.vid; });
          if (!outros.length) { removerAviso(); return; }

          var total = (cart.total_price || 0) + (jaNoCarrinho ? 0 : p.preco * p.qtd);
          var texto = jaNoCarrinho
            ? 'Valores considerando os itens do seu carrinho (total ' + brl(total) + ').'
            : 'Valores considerando os itens do seu carrinho + este produto (total ' + brl(total) + ').';

          var el = bloco.querySelector('[data-davila-aviso-frete]');
          if (el && el.textContent === texto) return; // nada mudou: nao mexe no DOM
          if (!el) {
            el = document.createElement('p');
            el.setAttribute('data-davila-aviso-frete', 'true');
            el.style.cssText = 'margin:6px 0 0;font-size:11px;line-height:1.4;color:#8a8a8a;';
            resultados.parentNode.insertBefore(el, resultados.nextSibling);
          }
          el.textContent = texto;
        })
        .catch(function () { /* aviso e' cosmetico: falha nao pode afetar a PDP */ });
    }

    var agendado = null;
    function agendar() {
      clearTimeout(agendado);
      agendado = setTimeout(atualizar, 300);
    }
    // O app redesenha os resultados a cada cotacao (CEP, variante, quantidade).
    // A propria insercao do aviso dispara o observador uma vez; o "nada mudou"
    // acima evita laco.
    new MutationObserver(agendar).observe(bloco, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    agendar();
  }

  /* --------------------------------------------------------
     Foto da galeria — o CSS deixa o clique passar pela camada
     invisivel (clique direito / segurar no celular chega na foto).
     Aqui o clique esquerdo na foto aperta o botao do Dawn, que abre a lightbox.
  -------------------------------------------------------- */
  function initGalleryImageClick() {
    document.addEventListener('click', function (e) {
      if (e.button !== 0 || e.target.tagName !== 'IMG') return;
      var opener = e.target.closest('.davila-pdp .product__modal-opener--image');
      if (!opener) return;
      var toggle = opener.querySelector('.product__media-toggle');
      if (toggle) toggle.click();
    });
  }

  /* --------------------------------------------------------
     Init
  -------------------------------------------------------- */
  function init() {
    initStickyCart();
    initPriceMirror();
    initVariantPriceUpdate();
    initEntregaFullTooltip();
    initGalleryMoreOverlay();
    initModalCarousel();
    initGalleryImageClick();
    initMobilePdpHero();
    initAvisoFreteCarrinho();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
